import type { ReactNode } from 'react';
import { Label } from '@fluentui/react-components';
import { usePaneStyles } from '../styles';

interface LabeledFieldProps {
  label: string;
  /** Right-aligned counter or status shown on the label's line. */
  meta?: ReactNode;
  required?: boolean;
  children: ReactNode;
}

/**
 * A label row with an optional right-aligned counter, then the control.
 *
 * Fluent's `Field` cannot express this. Its `Label` shrink-wraps to its content, so a
 * full-width flex child has no free space for the counter to be pushed into, and `required`
 * renders its asterisk after that child - which puts it on the next line.
 */
export function LabeledField({ label, meta, required, children }: LabeledFieldProps) {
  const styles = usePaneStyles();
  return (
    <div className={styles.field}>
      <div className={styles.labelRow}>
        <Label {...(required ? { required: true } : {})}>{label}</Label>
        {meta != null ? <span className={styles.count}>{meta}</span> : null}
      </div>
      {children}
    </div>
  );
}
